import Tag from './src/tag.vue'
import { SFCWithInstall, withInstall } from '@touchvue/utils'

export const ToTag: SFCWithInstall<typeof Tag> = withInstall(Tag)

export default ToTag

export * from './src/instance'
